import { defineMessages } from 'react-intl';

export default defineMessages({
  giftCardsTitle: {
    id: 'gift.giftHeader.title',
    description: 'Title for gift overview page',
    defaultMessage: 'Gift cards',
  },
  giftCardBreadcrumb: {
    id: 'gift.giftCardBreadcrumb.title',
    description: 'Breadcrumb title on Create eGift form page',
    defaultMessage: 'Gift',
  },
  createEGift: {
    id: 'gift.eGift.create',
    defaultMessage:
      'Create {numberOfRecipients, plural, one {eGift} other {eGifts}}',
    description: 'Heading for Create eGift form page',
  },
  termsAndConditionsAgreement: {
    id: 'gift.eGift.termsAndConditionsAgreement',
    description: 'Terms and Conditions agreement on create egift form',
    defaultMessage:
      'By purchasing this eGift, I have read and agree to the Starbucks Card Terms & Conditions.',
  },
});
